import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';

interface ItemPendente {
  seq:        number;
  codprod:    number;
  descricao:  string;
  refforn:    string;
  observacao: string;
  qtd:        number;
  codvol:     string;
}

@Component({
  selector: 'app-conferencia-pendente-itens',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule],
  templateUrl: './conferencia-pendente-itens.component.html',
  styleUrls: ['./conferencia-pendente-itens.component.css']
})
export class ConferenciaPendenteItensComponent implements OnInit {
  @Input() nunota!: number;
  @Output() voltar      = new EventEmitter<void>();
  @Output() resolvido   = new EventEmitter<void>();
  @Output() editarVenda = new EventEmitter<number>();

  itens:       ItemPendente[] = [];
  carregando   = false;
  erro         = '';
  resolvendo   = false;
  erroResolver = '';
  modalResolver = false;

  constructor(private gateway: SankhyaGatewayService) {}

  ngOnInit(): void {
    if (this.nunota) this.carregarItens();
  }

  onEditarVenda(): void {
    this.editarVenda.emit(this.nunota);
  }

  carregarItens(): void {
    this.carregando = true;
    this.erro = '';
    this.gateway.buscarItensPendentesPendencia(this.nunota).subscribe({
      next: (res: any) => {
        this.carregando = false;
        if (res?.sucesso) {
          this.itens = res.itens as ItemPendente[];
        } else {
          this.erro = res?.erro ?? 'Erro ao carregar itens.';
        }
      },
      error: (err: any) => {
        this.carregando = false;
        this.erro = err?.error?.erro ?? err?.message ?? 'Erro ao carregar itens.';
      }
    });
  }

  onVoltar(): void { this.voltar.emit(); }

  abrirModalResolver(): void {
    this.erroResolver = '';
    this.modalResolver = true;
  }

  fecharModalResolver(): void {
    if (this.resolvendo) return;
    this.modalResolver = false;
  }

  confirmarResolver(): void {
    if (this.resolvendo) return;
    this.resolvendo    = true;
    this.erroResolver  = '';
    this.modalResolver = false;
    this.gateway.resolverPendenciaVendedor(this.nunota).subscribe({
      next: (res: any) => {
        this.resolvendo = false;
        if (res?.sucesso) {
          this.resolvido.emit();
        } else {
          this.erroResolver = res?.erro ?? 'Erro ao resolver pendência.';
        }
      },
      error: (err: any) => {
        this.resolvendo   = false;
        this.erroResolver = err?.error?.erro ?? err?.message ?? 'Falha ao resolver pendência.';
      }
    });
  }
}
